"use client";

// External imports
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";

// Local imports
import classes from "./style.module.css";
import languageConfig from "@/export/config";
import Title from "./components/Title";
import List from "./components/List";
import TextInput from "./components/TextInput";

export default function FontsPage() {
  const router = useRouter();

  // State to handle the custom text inside the input box
  const [text, setText] = useState("");

  useEffect(() => {
    if (router) {
      if (text === languageConfig?.routes.fonts?.input.textOptions[0]) {
        router.replace("#");
      } else {
        router.replace(`#${text}`);
      }
    }
  }, [text, router]);

  useEffect(() => {
    if (window.location.hash) {
      setText(decodeURIComponent(window.location.hash.split("#")[1]));
    } else {
      setText(languageConfig?.routes.fonts?.input.textOptions[0] || "");
    }
  }, []);

  return (
    <main className={`${classes.main}`}>
      <Title />
      <TextInput text={text} setText={setText} />
      <List text={text} />
    </main>
  );
}
